import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ApiService } from '../api.service';
import { DomSanitizer } from '@angular/platform-browser';
import { HandlerService } from '../handler.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ThumbnailService } from '../thumbnail.service';
import { LaunchNavigator } from '@ionic-native/launch-navigator/ngx';
import { NativeGeocoder } from '@ionic-native/native-geocoder/ngx';
import { AuthService } from '../auth.service';
import { LocationService } from '../location.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BottomSheet } from '../bottom.sheet';

@Component({
  selector: 'app-item-purchase',
  templateUrl: './item-purchase.component.html',
  styleUrls: ['./item-purchase.component.scss'],
})
export class ItemPurchaseComponent   {
  @ViewChild('map',{static: false}) mapElement: ElementRef;
  serviceID;
  cartload: boolean = false;
  orderId;
  fontStyle;
  pic;
  showDiv:boolean=false;
  showAdd:boolean=true;
  slideOpts;
  numb;
  ProductObj = [];
  itemtypeObj=[];
  showQty;
  items = [];
  cartView:boolean=false;
  spinner:boolean=false;
  loader:boolean=false;
  orderItems: any =[];
  id;
  storeObj: any = [];
  filterData: any = [];
  dateFormat;
  url; 
  search;
  serviceDetails: any = [];
  serviceInc:boolean = false;
  servHead:boolean = false;
  packHead:boolean = false;
  redirect:boolean = false;
  typePopup:boolean;
  show:boolean = true;
  indService;
  category;
  categoryCode;
  serviceName;
  orderQty = 0;
  modelObj;
  makeObj;
  modelName;
  modelId;
  makeName;
  makeId;
  typeObj;
  typeName;
  typeId;
  orderAmountStr;
  requestId:any=[];
  cateCode;
itemCategoryObj:any=[];
  itemTypeId;
  typeCode;
  region;
  serviceObj:any;
  otherItemPop:boolean;
  showSearch:boolean;
  src:any;
  video:boolean = false;
  cost;
  serviceId;
  dummy;
  amtLoader:boolean;
  brand:boolean = false;
  enter:boolean = true;
  totalStoreObj = [];
  brandObj=[];
  
    constructor(   private service: ApiService,protected sanitizer: DomSanitizer,
      public handler: HandlerService,
      public router: Router,
      public translate: TranslateService,
      public thumb:ThumbnailService,
      private launchNavigator: LaunchNavigator,
        private geoCoder:NativeGeocoder,
      public auth: AuthService,  public location: LocationService,   public bottomSheet: MatBottomSheet) { }
  
  ionViewWillEnter(){
     this.dateFormat = this.auth.getDateformat();  
     this.url = window.location.href; 
     if(this.url.includes('edit-purchase')){
      this.orderId = this.url.split('/').pop();
      this.getOrderById();
     }else{
      this.id = this.url.split('/').pop();
      this.getProducts();  
      this.getBrands();
     }
    
     this.loader = true; 
    
  }

  getOrderById(){
    this.service.getOrderById(this.orderId).subscribe((res:any) => {
      if (res) {
        localStorage.setItem('shopId',res.orgId)
        this.orderItems = res;
        this.id=res.categoryId;
        this.getProducts();  
        this.getBrands();
      }
    },
      err => {
             this.handler.err(err.error)
      })
   
  }

  back(){
    if(this.auth.loged()){
      this.router.navigate(['/bookservice1'])
    }else{
      this.router.navigate(['/bookservice'])
    }
  }

  playVideo(data){
    if(data.docId != undefined){
      this.video = true;
      this.service.getAdImage(data.docId).subscribe((res:any)=>{
        this.src= this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(res));
      },
      err=>{
        this.handler.err(err);
      })
    }else{
      this.handler.res("No Video Found")
    }  
  }

  closeVideo(){
    this.video = false;
    this.src = undefined;
  }

  

    ionViewWillLeave(){
      this.serviceInc = false;
      this.redirect = false;
    }

    getDetails(data){
      this.indService = data;
      if(!this.auth.loged()){
        this.serviceInc = true;
        // this.itemCategory(); 
      }else{
        this.redirect = true;
        // this.itemCategory(); 
        setTimeout(() => {
          // this.route();
        },2000); 
      
      }
       
    }

        
    signIn(){  
      sessionStorage.setItem('id',this.id)  
      var post={
        "contactNbrMob":'+91'+ this.numb,
        "orgCode":'YB',
        "paless": true,
        "userType":1,
        "roles": ['CUST'],
        "appId":14,
        "addresses":[
          {
            "cityId": this.location.cityId,
            "stateId": this.location.stateId,
            "regionId":this.location.regionId,
            "street":this.location.street,
            "zipcode":this.location.zipcode,
            "lat": this.location.lat,
            "lon": this.location.lon,
            "type": 2,
            "orgId":790
          }
        ]
      }  
      this.service.customerLogin(post).subscribe((res:any)=>{
       if(res){
        window['mock'] = res;  
        this.handler.loginRes(res); 
         this.serviceInc=false;
         this.numb="";
        this.router.navigate(['/validateForPurc'])
       }
      })
      
    
    }

 

      addQuantity(data) { 
        this.showDiv=false;  
        if(!this.auth.loged()){
          this.serviceInc=true;
        } else{
          this.storeObj.map(res => {
            if (res != data)
              res.select = false;
            else
              res.select = true
          })      
            data.showQty = data.showQty + 1;
            if(data.showQty > 0){
              this.cartView = true;
            }
          if(!this.orderId){       
            this.createOrder(); 
          } else{
            this.updateOrder();
          }  
        
        }  
 
    }

      decQuantity(data) { 
        this.showDiv=false;  
        this.storeObj.map(res => {
          if (res != data)
            res.select = false;
          else
            res.select = true
        })
           if (data.showQty == 0)
            data.showQty = data.showQty;
          else {
            data.showQty = data.showQty - 1;
            this.updateOrderItem()
          }
      }
      createOrder() {
        this.cartload = true;
        this.showAdd = false;
        let item = this.storeObj.find(res => res.showQty != 0 && res.select);
      
        item.qty = 1;
        let postData = { 
          "customerId":localStorage.getItem('currentUserId'),
          "orgId":localStorage.getItem('organizationId'),  
          "categoryId":this.id, 
          "delDoorNbr": this.location.houseNbr,
          "delStreet": this.location.street,
          "delCity": this.location.cityId,
          "delState":this.location.stateId,
          "delRegion":this.location.regionId,
          "status": 1,
          "paymtStatus": 1,
          "paymtMode": 1,
          "orderType" : 2,
          "items" :[
              {
                  "id" : item.id,
                  "qty": item.qty,
                  "productId":item.productId
              }
          ]     
        }
     
        this.service.placeOrder(postData).subscribe((res: any) => {
          if(res){
            this.orderId = res.id;
            this.cartload = false;
            this.orderItems = res;        
            if (this.orderItems.items) {
              this.items.map(dat => {
                this.orderItems.items.map(dat1 => {
                  if (dat.id == dat1.id)
                    dat.showQty = dat1.qty;
                })
              })
            }
            // this.getOrder(this.orderId);
            this.showDiv=true;
            this.showAdd=true;
          }else{
            this.showAdd=true;
            this.showDiv=true; 
          }
       
        },
          err => {
            this.handler.err(err);
                this.cartload = false;  
          })
      }

    
      updateOrder() {  
        this.showAdd=false;
        let item;
        item = this.storeObj.find(dat => dat.showQty != -1 && dat.select);      
          item.qty = 1;
        let products = {      
          "items" :[
            {
                "id" : item.id,
                "qty" :item.qty,
                "productId":item.productId
            }
        ],
  orderType: 2,
         }
        this.cartload = true;
        this.service.orderItemPost(this.orderId, item.id, products).subscribe((res:any) => {
          if(res){
            // this.getOrder(this.orderId);
            this.cartload = false;
            this.orderItems = res;        
            if (this.orderItems.items) {
              this.items.map(dat => {
                this.orderItems.items.map(dat1 => {
                  if (dat.id == dat1.id)
                    dat.showQty = dat1.qty;
                })
              })
            }
            this.showDiv=true;
            this.showAdd=true;
          }
    
        },
          err => {
            this.cartload = false;
                  this.handler.err(err)
          })
      }

      async updateOrderItem(){
        let item;
        item = this.storeObj.find(dat => dat.showQty != -1 && dat.select);
        item.qty = item.showQty;
        let products = {      
          "items" :[
            {
                "id" : item.id,
                "qty" :item.qty,
                "productId":item.productId
            }
        ],
          orderType: 2 }  
          this.cartload=true;
          this.service.updateOrderItem(this.orderId, item.id, products).subscribe(res => {
            if(res){
              this.cartload = false;
              this.showDiv=true;
              this.showAdd=true;
              this.orderItems = res;          
              if (this.orderItems.items) {
                this.items.map(dat => {
                  this.orderItems.items.map(dat1 => {
                    if (dat.id == dat1.id)
                      dat.showQty = dat1.qty;
                  })
                })
              }
            }
            // this.getOrder(this.orderId);
           
          },
            err => {
              this.cartload = false;
                   this.handler.err(err)
            })
        }

       

     routeToReq(){
       if(this.orderId && this.orderItems.orderAmountStr>0){
        this.redirect = true;        
        setTimeout(() => {
           this.route();
         },2000); 
       
       
       }    
      
     }


     route(){
      sessionStorage.setItem('orderId', this.orderId) 
       this.router.navigate(['/item-purchase'])

     }

     routeToItems(item){
      this.itemtypeObj.map(res=>{
        if(res.id == item.id){
          res.highlight = true;
        }else{
          res.highlight = false;
        }
      })
      this.otherItemPop=false;
      this.enter = false;
      this.itemTypeId=item.id;
      this.getItems();
     }

     routeToBrand(item){
      this.brandObj.map(res=>{
        if(res.id == item.id){
          res.highlight = true;
        }else{
          res.highlight = false;
        }
      })
      this.otherItemPop=false;
      this.enter = false;
      this.itemTypeId=item.id;
      this.getItems();
     }

      getItems(){ 
      if(this.enter){
        console.log(this.orderItems)
        this.service.getItemProductByCateId(this.id).subscribe((res:any)=>{
          if(res){
            this.storeObj = res;   
            this.storeObj.map(res1=>{
             Object.assign(res1, { select: false, qty: 0, showQty: 0,success:false}) 
            })
            if(this.url.includes('edit-purchase')){
              this.storeObj.map(dat=>{
                this.orderItems.itemOrders.map(dat1=>{
                  if(dat.id == dat1.itemId){
                    dat.qty = dat1.qty;
                    dat.showQty = dat1.qty;
                    this.showDiv = true;
                    this.cartView = true;
                  }
                })
              })
            } 
            this.totalStoreObj = this.storeObj;
            this.loader=false;  
          
          }else{
            this.loader=false;
            this.storeObj=[];
            this.totalStoreObj=[];
          }
           
       },err =>{
         this.handler.err(err)
         this.loader = false;    
       }) 
    }else{
      if(!this.brand){
        this.storeObj = this.totalStoreObj.filter(res=>{return res.productId == this.itemTypeId});
        if(this.storeObj.length == 0){
          this.handler.res("No Products Found")
        }
      }else{
        this.storeObj = this.totalStoreObj.filter(res=>{return res.brand == this.itemTypeId});
        if(this.storeObj.length == 0){
          this.handler.res("No Products Found")
        }
      }
    }
  }


  getBrands(){
    this.service.getAllbrand().subscribe((res:any) => {
      this.brandObj = res;
      Object.assign(this.brandObj,{highlight: false})
    })
  }

    getProducts(){
      this.loader=true;
      this.service.getAllProduct().subscribe((res:any)=>{
        if(res){
          this.itemtypeObj=res;
          this.itemtypeObj=this.itemtypeObj.filter(res=>{return res.purchaseCategory==this.id});
        }
      })
      this.getItems(); 
    }


     closePop(){
      this.serviceInc=false;
      this.numb="";
    }
    
    swapSearch(){
     this.brand = !this.brand;
     this.storeObj = this.totalStoreObj;
     if(!this.brand){
      this.itemtypeObj.map(res=>{
        Object.assign(res,{highlight: false})
      })
     }else{
      this.brandObj.map(res=>{
        Object.assign(res,{highlight: false})
      })
     }
    }
    
}